__turbopack_context__.v({
  "background": "hBcnOa_background",
  "container": "hBcnOa_container",
  "isCompactHover": "hBcnOa_isCompactHover",
  "isDisabled": "hBcnOa_isDisabled",
  "isOpacity": "hBcnOa_isOpacity",
});
